<template lang='pug'>
div(:class='$style[`cc-order-pay-li-wrap`]' v-on-clickaway='handleCloseDetailOnBlur')
  div(:class='$style[`cc-order-pay-base`]')
    //- div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-no`]]')
    //-   span(:class='$style[`cc-order-pay-title`]')!= '訂單編號'
    //-   span.font-bold(:class='$style[`cc-order-pay-info`]') {{ stuffDetail.MerchantTradeNo }}

    div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-date`]]')
      span(:class='$style[`cc-order-pay-title`]') 建立日期
      span.font-bold(:class='$style[`cc-order-pay-info`]') {{ stuffDetail.purchaseDate }}

    div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-price`]]') {{ stuffDetail.TotalAmount }}
      span(:class='$style[`cc-order-pay-title`]') 總金額(元)
      span.font-bold(:class='$style[`cc-order-pay-info`]') {{ stuffDetail.TotalAmount }}
    
    div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-status`]]') 
      span(:class='$style[`cc-order-pay-title`]') 交易付款
      span.font-bold.font-doctor-theme(v-if='stuffDetail.TradeStatus === `1`' :class='$style[`cc-order-pay-info`]') 已付款
      span.font-bold.font-disable-theme(v-else-if='stuffDetail.TradeStatus === `2`' :class='$style[`cc-order-pay-info`]') 申請退貨
      span.font-bold.font-error-theme(v-else :class='$style[`cc-order-pay-info`]') 交易失敗

    div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-status`]]') 
      span(:class='$style[`cc-order-pay-title`]') 支付方式
      span.font-bold(:class='$style[`cc-order-pay-info`]' style='padding: 0')
        figure(v-if='stuffDetail.payVendor === `ecpay-credit`' style='max-width: 90px')
          img(:src='`${STATIC_URL}images/mall/ecpay.webp`' width='100%')
        figure(v-else-if='stuffDetail.payVendor === `ecpay-cvs`' style='max-width: 90px')
          img(:src='`${STATIC_URL}images/mall/ecpay_cvs.webp`' width='100%')
        figure(v-else-if='stuffDetail.payVendor === `linepay`' style='max-width: 90px')
          img(:src='`${STATIC_URL}images/mall/linepay.webp`' width='100%')
      
    div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-status`]]') 
      span(:class='$style[`cc-order-pay-title`]') 訂單狀態
      span.font-bold(:class='$style[`cc-order-pay-info`]') {{ stuffDetail.finalstatus }}
    

    div(:class='[$style[`cc-order-pay-base-grid`], $style[`cc-order-pay-base-controller`]]')
      button(
        tabindex='0'
        :aria-label='showDetail ? `縮合` : `展開`'
        :class='[$style[`cc-order-pay-info`], $style[showDetail ? `cc-opened` : ``]]' @click='handleClickShowDetail') {{ showDetail ? '縮合' : '展開' }}
        IconOpenArrow(:size='18' :color='`#262626`')

  div(v-show='showDetail' :class='$style[`cc-order-pay-detail`]')
    div(:class='$style[`cc-order-pay-detail-left`]')
      header(:class='$style[`cc-order-pay-detail-left-header`]')
        span(:class='$style[`cc-order-pay-detail-left-title`]') 訂單編號
        span.font-bold(:class='$style[`cc-order-pay-detail-left-tradeNo`]') {{ stuffDetail.MerchantTradeNo }}
      ul(:class='$style[`cc-order-pay-detail-ul`]')
        li(v-for='items, index in stuffDetail.ItemName' :key='index' :class='$style[`cc-order-pay-detail-li`]') {{ items }}
    div(:class='$style[`cc-order-pay-detail-right`]')
      button(
        v-if='stuffDetail.TradeStatus === `1` && stuffDetail.ItemType !== `subscribe`'
        title='我要退貨'
        tabindex='0'
        aria-label='我要退貨'
        :class='$style[`cc-order-pay-return-btn`]'
        @click='handleClickReturnOrder') {{ showReturnPanel ? '取消退貨' : '我要退貨' }}

  div(v-show='showReturnPanel' :class='$style[`cc-order-pay-return`]')
    div(:class='$style[`cc-order-pay-return-panel`]')
      div(:class='$style[`cc-order-pay-return-selector`]')
        SelectModel(
          v-model='formConfig.category'
          title='原因分類'
          :class='$style[`cc-select-area`]'
          :placehold='`原因分類`'
          :optionList='[`商品瑕疵`, `不適合我`, `價格因素`, `其他`]'
          :errorValue='formVerify.categoryError'
          @clearErrorMsg="(value) => {this.formVerify.categoryError = value}")

      div(:class='$style[`cc-order-pay-return-textarea`]')
        TextAreaer(
          v-model.trim='formConfig.opinion'
          title='退貨原因'
          :autoSize='true'
          :class='$style[`cc-textarea`]'
          :resetButton='false'
          :placehold='`退貨原因`'
          :errorValue='formVerify.opinionError'
          @clearErrorMsg='(value) => {this.formVerify.opinionError = value[0];}')
        button(
          title='送出'
          tabindex='0'
          aria-label='送出'
          :class='$style[`cc-order-pay-return-textarea-btn`]'
          @click='handleCheckProgressBeforeSend')
          span(v-show='!showLoading') 送出
          IconLoading(
            v-show='showLoading'
            :size='20'
            :color='`#b1b1b1`')



</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import IconOpenArrow from '../../icon/OpenArrow';
import IconLoading from '../../icon/Loading';
// import Inputer from '../common/Input';
import SelectModel from '../common/SelectModel';
import TextAreaer from '../common/TextArea';

import {
  putEcpayUserReturnOrder,
} from '../../../js/restapi';

export default {
  components: {
    IconOpenArrow,
    IconLoading,
    // Inputer,
    SelectModel,
    TextAreaer,
  },

  mixins: [clickaway],

  props: {
    stuffId: {
      type: Number,
      default: 0,
    },
    stuffDetail: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      showLoading: false,
      showReturnPanel: false,
      showDetail: false,
      formConfig: {
        category: '',
        opinion: '',
      },
      formVerify: {
        categoryError: false,
        opinionError: false,
      },
      verifyAllPass: true,
      nextTick: 1,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleCloseDetailOnBlur() {
      this.showDetail = false;
      this.showReturnPanel = false;
    },

    handleClickShowDetail() {
      this.showDetail = !this.showDetail;
      this.showReturnPanel = false;
    },

    handleClickReturnOrder() {
      this.showReturnPanel = !this.showReturnPanel;
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;

      if (!this.formConfig.category) {
        console.log('category Error');
        this.formVerify.categoryError = true;
        this.verifyAllPass = false;
      }

      if (!this.formConfig.opinion) {
        console.log('opinion Error')
        this.formVerify.opinionError = true;
        this.verifyAllPass = false;
      }
    },

    axiosSendReturnReasonResult() {
      if (!this.verifyAllPass) { return; }
      this.showLoading = true;

      const CONFIG = {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      };

      const PASS_DATA = {
        auth_id: `${this.loginDjangoId}`,
        // date: `${res.data}`,
        category: this.formConfig.category,
        opinion: this.formConfig.opinion,
        MerchantTradeNo: this.stuffDetail.MerchantTradeNo
      }

      putEcpayUserReturnOrder('/', PASS_DATA, CONFIG)
        .then((res) => {
          console.log('putEcpayUserReturnOrder Success');
          
          this.changePopBoxStatus({
            active: true,
            include: 'sendConfirm',
          });

          this.$emit('detectStatusChange');
          this.showLoading = false;

          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
            this.showReturnPanel = false;
          }, this.POP_DURATION);
        })
        .catch((err) => {
          console.log('putEcpayUserReturnOrder Error');
        })

    },

    async handleCheckProgressBeforeSend() {
      await this.handleFormsCheckToPass();
      await this.axiosSendReturnReasonResult();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      authJwtToken: 'user/exportUserJwtToken',
      loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/account/orderPay.scss';
</style>
